<template>
  <div ref="loader" class="loader">
    <img
      :src="requireAsset('loaders/loader.gif')"
      alt=""
      class="loader__image"
      @load="setCarga()"
    />
  </div>
</template>

<script>
import Data from '@/assets/backend/data.json';

import Aplicacion from '@/assets/backend/classes/Aplicacion.js';
import Producto from '@/assets/backend/classes/Producto.js';
import Modelo from '@/assets/backend/classes/Modelo.js';
import Campo from '@/assets/backend/classes/Campo.js';
import Caracteristica from '@/assets/backend/classes/Caracteristica.js';
import Filtro from '@/assets/backend/classes/Filtro.js';
import Valor from '@/assets/backend/classes/Valor.js';
import tCorrespondencia from '@/assets/backend/t-correspondencia.json';
// import LZString from 'lz-string';

export default {
  name: 'Loader',
  data() {
    return {
      loaderDuration: 1750,
      params: {},
    };
  },
  mounted() {
    console.log('Loader mounted');
  },
  methods: {
    async setDefaultValues(aplicacion) {
      aplicacion.productos.forEach((productoEl) => {
        productoEl.modelos.forEach((modeloEl) => {
          const estandares = modeloEl.estandares;
          const referencia = modeloEl
            .getCampo('referencias')
            .getCaracteristica('modelo').valorSel;
          const mueble = modeloEl
            .getCampo('mueble')
            .getCaracteristica('modelo').valorSel;

          const match = estandares.find(
            (estandar) =>
              estandar.referencia === referencia && estandar.mueble === mueble
          );

          const keys = [
            'dimx',
            'dimy',
            'dimz',
            'unidades',
            'cubeta1_dimx',
            'cubetas_posx',
            'cubeta2_dimx',
          ];

          for (const caracteristica of keys) {
            if (caracteristica in match) {
              const valor = match[caracteristica];
              let campo;
              switch (caracteristica) {
                case 'dimx':
                case 'dimy':
                case 'dimz':
                  campo = 'lavabo';
                  break;
                case 'unidades':
                case 'cubeta1_dimx':
                case 'cubetas_posx':
                case 'cubeta2_dimx':
                  campo = 'cubetas';
                  break;
                default:
                  continue;
              }
              modeloEl
                .getCampo(campo)
                .getCaracteristica(caracteristica).valorSel = valor;
              aplicacion.seleccion[productoEl.cod][modeloEl.cod][campo][
                caracteristica
              ] = valor;
            }
          }
        });
      });
    },
    async getParams(aplicacion, tCorrespondencia) {
      // Extraer el código del producto y del modelo desde la aplicación
      const prodCod = aplicacion.getProducto().cod;
      const modCod = aplicacion.getProducto().getModelo().cod;

      // Obtener la parte de la tabla que corresponde a este producto y modelo
      const mapping =
        tCorrespondencia[prodCod] && tCorrespondencia[prodCod][modCod];
      if (!mapping) {
        console.error('No se encontró correspondencia para:', prodCod, modCod);
        return;
      }

      // Construir el mapa inverso para poder transformar un código (p.ej. "B2")
      // en el objeto { group, field } que nos indica a qué grupo y campo corresponde
      const inverseMapping = {};
      Object.keys(mapping).forEach((group) => {
        const groupMapping = mapping[group];
        Object.keys(groupMapping).forEach((field) => {
          const code = groupMapping[field];
          inverseMapping[code] = { group, field };
        });
      });

      // Obtener los parámetros de la URL
      const urlParams = new URLSearchParams(window.location.search);

      // Recorrer cada parámetro decodificando clave y valor
      for (let [key, value] of urlParams.entries()) {
        const decodedKey = decodeURIComponent(key);
        const decodedValue = decodeURIComponent(value);

        // Buscar la clave en el mapa inverso
        if (inverseMapping.hasOwnProperty(decodedKey)) {
          const { group, field } = inverseMapping[decodedKey];

          // Obtener el objeto de campo a partir del grupo (ej. "lavabo", "cubetas", "mueble", etc.)
          const campoObj = aplicacion.getProducto().getModelo().getCampo(group);
          if (campoObj) {
            const caracteristicaObj = campoObj.getCaracteristica(field);
            if (caracteristicaObj) {
              // Convertir el valor según el tipo (number, boolean o string)
              if (caracteristicaObj.tipo === 'number') {
                caracteristicaObj.valorSel = parseFloat(decodedValue);
              } else if (caracteristicaObj.tipo === 'boolean') {
                caracteristicaObj.valorSel = decodedValue === 'true';
              } else {
                caracteristicaObj.valorSel = decodedValue;
              }
              // Actualizar la selección en la aplicación
              aplicacion.seleccion[prodCod][modCod][group][field] =
                caracteristicaObj.valorSel;
            }
          }
        }
      }
    },
    async setCarga() {
      const start = performance.now();

      const url = window.location.href;
      const parts = new URL(url).pathname.split('/');

      const aplicacion = new Aplicacion();
      aplicacion.loading = true;
      aplicacion.config.rightOrientation = true;
      aplicacion.cotas = false;
      aplicacion.productoSel = parts[2] ?? Data.productoDef;
      aplicacion.seleccion.producto = aplicacion.productoSel;

      Data.productos.sort((a, b) => a.orden - b.orden);
      Data.productos.forEach((productoEl) => {
        const producto = new Producto();
        producto.cod = productoEl.cod;
        producto.literales = productoEl.literales;
        producto.modeloSel = parts[3] ?? new String();
        aplicacion.seleccion.modelo = aplicacion.modeloSel;
        aplicacion.seleccion[productoEl.cod] ??= {};
        productoEl.modelos.sort((a, b) => a.orden - b.orden);
        productoEl.modelos.forEach((modeloEl) => {
          const modelo = new Modelo();
          modelo.cod = modeloEl.cod;
          modelo.literales = modeloEl.literales;
          modelo.estandares = modeloEl.estandares;
          modelo.campoSel = modeloEl.campoDef;
          aplicacion.seleccion[productoEl.cod][modeloEl.cod] ??= {};
          modeloEl.campos.sort((a, b) => a.orden - b.orden);
          modeloEl.campos.forEach((campoEl) => {
            const campo = new Campo();
            campo.seleccion = aplicacion.seleccion;
            campo.cod = campoEl.cod;
            campo.literales = campoEl.literales;
            if (campoEl.condicion) {
              campo.condicion = campoEl.condicion;
            }
            campo.visible = campoEl.visible;
            aplicacion.seleccion[productoEl.cod][modeloEl.cod][campoEl.cod] ??=
              {};
            campoEl.caracteristicas.sort((a, b) => a.orden - b.orden);
            campoEl.caracteristicas.forEach((caracteristicaEl) => {
              const caracteristica = new Caracteristica();
              caracteristica.seleccion = aplicacion.seleccion;
              caracteristica.cod = caracteristicaEl.cod;
              caracteristica.literales = caracteristicaEl.literales;
              caracteristica.valorDef = caracteristicaEl.valorDef;
              if (caracteristicaEl.relaciones) {
                caracteristica.relaciones = JSON.parse(
                  caracteristicaEl.relaciones
                );
              }
              if (caracteristicaEl.center) {
                caracteristica.center = JSON.parse(caracteristicaEl.center);
              }
              if (caracteristicaEl.referencias) {
                caracteristica.referencias = caracteristicaEl.referencias;
              }
              if (caracteristicaEl.condicion) {
                caracteristica.condicion = caracteristicaEl.condicion;
              }
              caracteristica.tipo = caracteristicaEl.tipo;
              if (caracteristicaEl.filtros) {
                caracteristicaEl.filtros.forEach((filtroEl) => {
                  const filtro = new Filtro();
                  filtro.cod = filtroEl.cod;
                  filtro.literales = filtroEl.literales;
                  filtro.valorSel = filtroEl.valorDef;
                  filtroEl.valores.forEach((valorEl) => {
                    const valor = new Valor();
                    valor.cod = valorEl.cod;
                    valor.literales = valorEl.literales;
                    if (valorEl.coleccionesCompatible) {
                      valor.coleccionesCompatible =
                        valorEl.coleccionesCompatible;
                    }
                    if (valorEl.texturasCompatible) {
                      valor.texturasCompatible = valorEl.texturasCompatible;
                    }
                    valor.seleccion = aplicacion.seleccion;
                    if (valorEl.condicion) {
                      valor.condicion = valorEl.condicion;
                    }
                    filtro.valores.push(valor);
                  });
                  caracteristica.filtros.push(filtro);
                });
              }
              switch (caracteristicaEl.tipo) {
                case 'number':
                  caracteristica.valorSel = parseFloat(
                    caracteristicaEl.valorDef
                  );
                  aplicacion.seleccion[productoEl.cod][modeloEl.cod][
                    campoEl.cod
                  ][caracteristicaEl.cod] = parseFloat(caracteristica.valorSel);
                  caracteristica.step = caracteristicaEl.step;
                  caracteristica.min = caracteristicaEl.min;
                  caracteristica.max = caracteristicaEl.max;
                  break;
                case 'enumerated':
                  caracteristica.valorSel = caracteristicaEl.valorDef;
                  aplicacion.seleccion[productoEl.cod][modeloEl.cod][
                    campoEl.cod
                  ][caracteristicaEl.cod] = caracteristica.valorSel;
                  caracteristicaEl.valores.sort((a, b) => a.orden - b.orden);
                  caracteristicaEl.valores.forEach((valorEl) => {
                    const valor = new Valor();
                    valor.cod = valorEl.cod;
                    valor.miniature = valorEl.miniature;
                    valor.literales = valorEl.literales;
                    valor.seleccion = aplicacion.seleccion;
                    if (valorEl.condicion) {
                      valor.condicion = valorEl.condicion;
                    }
                    if (valorEl.filtros) {
                      valor.filtros = valorEl.filtros;
                    }
                    caracteristica.valores.push(valor);
                  });
                  break;
                case 'boolean':
                  caracteristica.valorSel = Boolean(caracteristicaEl.valorDef);
                  aplicacion.seleccion[productoEl.cod][modeloEl.cod][
                    campoEl.cod
                  ][caracteristicaEl.cod] = Boolean(caracteristica.valorSel);
                  break;
              }
              campo.caracteristicas.push(caracteristica);
            });
            modelo.campos.push(campo);
            modelo.referenciaSel = modelo
              .getCampo('referencias')
              .getCaracteristica('modelo').valorSel;
          });
          producto.modelos.push(modelo);
        });
        aplicacion.productos.push(producto);
      });

      await this.setDefaultValues(aplicacion);
      await this.getParams(aplicacion, tCorrespondencia);

      const end = performance.now();
      const cargaTime = end - start;

      setTimeout(() => {
        const language = this.$store.state.language || 'es';
        const currentPath = window.location.pathname;
        const pathParts = currentPath.split('/').filter(Boolean);
        if (pathParts[0] !== language) {
          pathParts.unshift(language);
        }
        const baseUrl = `${window.location.origin}/${pathParts.join('/')}`;
        window.history.replaceState({}, document.title, baseUrl);
        console.log(aplicacion);
        this.$emit('setAplicacion', aplicacion);
      }, this.loaderDuration + cargaTime);
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%;
  height: 100%;
  background-color: black;

  &__image {
    width: 100%;
    max-width: 300px;
  }
}
</style>
